import { render, staticRenderFns } from "./DeleteMarketRuleCommunity.vue?vue&type=template&id=32e505e6"
import script from "./DeleteMarketRuleCommunity.vue?vue&type=script&lang=js"
export * from "./DeleteMarketRuleCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports